import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import './Page.css';

const NotFound = () => (
  <div className="page">
    <SeoHead
      title="Page not found | Unaffected Healthcare"
      description="The page you are looking for does not exist or has moved."
      keywords=""
      noindex
    />
    <section className="page-content">
      <div className="container">
        <div className="content-section" style={{ textAlign: 'center', padding: '48px 0' }}>
          <h1 className="section-title">Page not found</h1>
          <p>The page you are looking for does not exist or may have moved.</p>
          <p style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap', marginTop: 24 }}>
            <Link to="/" className="btn btn-primary">Go to home</Link>
            <Link to="/blog" className="btn">Read our blog</Link>
            <Link to="/contact" className="btn">Contact us</Link>
          </p>
        </div>
      </div>
    </section>
  </div>
);

export default NotFound;
